<template>
  <div class="ls-shrub-and-hedge">
    <BushSVG :size="sizeAndText[size].svgSize" color="primary" class="ls-shrub-and-hedge--svg" />
    <p v-if="screenSize.desktop" class="ls-shrub-and-hedge--text">
      {{ sizeAndText[size].desktopText }}
    </p>
    <div v-else>
      <p class="ls-shrub-and-hedge--text">{{ sizeAndText[size].mobileUpperText }}</p>
      <p class="ls-shrub-and-hedge--text lower">{{ sizeAndText[size].mobileLowerText }}</p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import VueTypes from 'vue-types';
import BushSVG from './BushSVG.vue';

export default {
  name: 'LsShrubAndHedge',
  components: {
    BushSVG,
  },
  props: {
    size: VueTypes.oneOf(['sm', 'md', 'lg']).isRequired,
  },
  computed: {
    ...mapState(['screenSize']),
    sizeAndText() {
      return {
        sm: {
          svgSize: this.screenSize.desktop ? 65 : 44,
          desktopText: 'Below 5ft tall',
          mobileUpperText: 'Below',
          mobileLowerText: '5ft tall',
        },
        md: {
          svgSize: this.screenSize.desktop ? 90 : 59,
          desktopText: '5ft - 10ft tall',
          mobileUpperText: 'Between',
          mobileLowerText: '5ft - 10ft tall',
        },
        lg: {
          svgSize: this.screenSize.desktop ? 115 : 74,
          desktopText: 'Over 10ft tall',
          mobileUpperText: 'Over',
          mobileLowerText: '10ft tall',
        },
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.ls-shrub-and-hedge {
  background-color: $primary-light;
  width: 100%;
  height: 150px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
}

.ls-shrub-and-hedge--svg {
  padding-bottom: 6px;
  @media (max-width: $mobile-max-width) {
    margin-bottom: 15px;
  }
}

.ls-shrub-and-hedge--text {
  padding: 6px 0 25px;
  font-weight: bold;
  color: $primary;
  text-align: center;
  @media (max-width: $mobile-max-width) {
    width: 90px;
    padding: 0;
  }
  &.lower {
    @media (max-width: $mobile-max-width) {
      padding: 0 0 25px;
    }
  }
}
.themed-app {
  .ls-shrub-and-hedge {
    background-color: $theme-color-primary-light;
  }
  .ls-shrub-and-hedge--text {
    color: $theme-color-primary;
  }
}
</style>
